<template>
  <div class="newJob column">
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <div class="content">
      <NewJob />
    </div>
  </div>
</template>

<script>
import NewJob from "@/components/NewJobAdmin.vue";
import Button from "@/components/Button.vue";
import Router from "@/router";

export default {
  name: "newJob",
  components: {
    NewJob,
    Button
  },
  data() {
    return {
      router: Router
    };
  }
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.newJob {
  .content {
    padding: 42px 35px;
    @media (max-width: $small) {
      padding: 7px;
    }
  }
}
</style>
